import DevolucaoMaterial from './DevolucaoMaterial';

export default DevolucaoMaterial;